module.exports = __webpack_public_path__ + "static/media/skgr.c81d46bf.png";